import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { IpVm } from '../models';
import { AppConfig } from './app.config';


@Injectable({
  providedIn: 'root'
})
export class OuterService {
  apiUrl = AppConfig.settings.ApiUrl;

  private http: HttpClient;
  publicIp: string;

  constructor(handler: HttpBackend, private toastr: ToastrService) {
    this.http = new HttpClient(handler);
  }

  getIp(): Promise<any> {
    return new Promise((resolve, reject) => {
      // this.http.get('https://freegeoip.live/json/', { headers: {} }).subscribe((response: any) => {
      //   resolve(response['ip']);
      // }, reject);
      this.http.get('https://ipgeolocation.abstractapi.com/v1/?api_key=63dc44e7d07544a99c70653a13efed9d', { headers: {} }).subscribe((response: any) => {
        resolve(response['ip_address']);
      }, reject);
    });
  }


  getIpString(): Promise<any> {
    return new Promise((resolve, reject) => {
      // this.http.get('https://freegeoip.live/json/', { headers: {} }).subscribe((response: any) => {
      //   this.publicIp = response['ip'];
      //   resolve(response['ip']);
      // }, reject);
      this.http.get('https://ipgeolocation.abstractapi.com/v1/?api_key=63dc44e7d07544a99c70653a13efed9d', { headers: {} }).subscribe((response: any) => {
        this.publicIp = response['ip_address'];
        resolve(response['ip_address']);
      }, reject);
    });
  }

  // Base Services ===========================================================================================================
  getDataByModel(path: string, model: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl + path, { params: model }).subscribe((response: any) => {
        resolve(response);
      }, reject);
    });
  }

  getData(path: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl + path).subscribe((response: any) => {
        resolve(response);
      }, reject);
    });
  }

  postDataByModel(path: string, model: object): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl + path, model).subscribe((response: any) => {
        resolve(response);
      }, reject);
    });
  }

  postId(path: string, id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl + path, id).subscribe((response: any) => {
        resolve(response);
      }, reject);
    });
  }

}
